<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-2">Abbreviations</h1>
<table>
<tbody>
<tr>
<td class="col1"><p class="t-left">AYBC</p></td>
<td class="col2"><p class="t-hang">Anchor Yale Bible Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">b.</p></td>
<td class="col2"><p class="t-hang">Babylonian Talmud</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">BDAG</p></td>
<td class="col2"><p class="t-hang">Bauer, Danker, Arndt, and Gingrich, <em>Greek-English Lexicon of the New Testament and Other Early Christian Literature</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>CD</em></p></td>
<td class="col2"><p class="t-hang">Karl Barth, <em>Church Dogmatics</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">CEB</p></td>
<td class="col2"><p class="t-hang">Common English Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JATS</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of the Adventist Theological Society</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JBL</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of Biblical Literature</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JSNT</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal for the Study of the New Testament</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>JTI</em></p></td>
<td class="col2"><p class="t-hang"><em>Journal of Theological Interpretation</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">LXX</p></td>
<td class="col2"><p class="t-hang">Septuagint</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">m.</p></td>
<td class="col2"><p class="t-hang">Mishnah</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NA<sup>27/28</sup></p></td>
<td class="col2"><p class="t-hang">Nestle-Aland <em>Novum Testamentum Graece</em>, 27th or 28th ed.</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NASB</p></td>
<td class="col2"><p class="t-hang">New American Standard Bible</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Neot</em></p></td>
<td class="col2"><p class="t-hang"><em>Neotestamentica</em></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NICNT</p></td>
<td class="col2"><p class="t-hang">New International Commentary on the New Testament</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NIV</p></td>
<td class="col2"><p class="t-hang">New International Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NKJV</p></td>
<td class="col2"><p class="t-hang">New King James Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NLT</p></td>
<td class="col2"><p class="t-hang">New Living Translation</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">NRSV</p></td>
<td class="col2"><p class="t-hang">New Revised Standard Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">PG</p></td>
<td class="col2"><p class="t-hang">Patrologia Graeca. Edited by J.-P. Migne. 162 vols. Paris, 1857–86. <a href="http://www.patristica.net/graeca" target="_blank">http://patristica.net/graeca/</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">PL</p></td>
<td class="col2"><p class="t-hang">Patrologia Latina. Edited by J.-P. Migne. 217 vols. Paris, 1844–64. <a href="http://www.patristica.net/latina" target="_blank">http://patristica.net/latina/</a></p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">PNTC</p></td>
<td class="col2"><p class="t-hang">Pillar New Testament Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Princ.</em></p></td>
<td class="col2"><p class="t-hang"><em>First Principles</em> (Origen)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left"><em>Sacrifices</em></p></td>
<td class="col2"><p class="t-hang"><em>On the Sacrifices of Cain and Abel</em> (Philo)</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">Sanh.</p></td>
<td class="col2"><p class="t-hang">Sanhedrin</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">THNTC</p></td>
<td class="col2"><p class="t-hang">Two Horizons New Testament Commentary</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">TNIV</p></td>
<td class="col2"><p class="t-hang">Today’s New International Version</p></td>
</tr>
<tr>
<td class="col1"><p class="t-left">WBC</p></td>
<td class="col2"><p class="t-hang">Word Biblical Commentary</p></td>
</tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006_Abbreviations.vue?197c611d